import { generateClassName } from '@klv/shared/utils/functions';

import * as styles from './styles/stat.module.scss';

import type { IStat } from './types';

const Stat = ({
  background = 'light',
  className,
  headline,
  subcopy,
  ...rest
}: IStat) => (
  <article className={generateClassName([styles.stat, styles[background], className])} key={JSON.stringify(headline + subcopy)} {...rest}>
    <div className={generateClassName([styles.headline, 'display2'])}>{headline}</div>
    <div className={generateClassName([styles.copy, 'h5'])}>{subcopy}</div>
  </article>
);

export default Stat;
